import {ImageUrl} from '../../classes/images/imageUrl';
import {ImageApiProvider} from '../../classes/images/providers/imageApiProvider';

/**
 * @name isImageApi
 */
export const isImageApi = (url: string): boolean =>
  ImageUrl.supports(url, new ImageApiProvider());
